import * as React from 'react';
import { Settings } from "../types";
import { SettingsContext } from '../context/SettingsContext';
import { HeaderNavigation } from "./HeaderNavigation";
import { FooterNavigation } from "./FooterNavigation";
import { QuickscanProvider } from "../provider/QuickscanProvider";
import { Steps } from "./Steps";

export const QuickScan = (props: Settings): JSX.Element => {

    return <SettingsContext.Provider value={props}>
        <QuickscanProvider>
                <div className={'c-quickscan'}>

                    <HeaderNavigation/>

                    <Steps />

                    <FooterNavigation/>

                </div>
        </QuickscanProvider>
    </SettingsContext.Provider>;
}
